import React from 'react';
import { Typography, Row, Col } from 'antd';
import { motion } from 'framer-motion';
import { Gift, EnvelopeSimple } from "@phosphor-icons/react";
import { standardVariants, containerVariants, hoverVariants } from '../../utils/useAnimations';

const { Title, Paragraph } = Typography;

interface HelpCardData {
  id: number;
  title: string;
  description: string;
  linkText?: string;
  linkUrl: string;
  src: string;
  icon?: React.ReactNode;
}

const helpData: HelpCardData[] = [
  {
    id: 1,
    title: "Faire un don",
    description: "Pour nous aider à payer le <b>nom de domaine</b>, payer des <b>intervenants experts accessibilité</b> (développeurs, sous-titreurs, auditeurs ...), ajouter des fonctionnalités pour <b>faire évoluer l'expérience</b>.",
    linkText: "Prochainement",//Accéder à la cagnotte Teepee
    linkUrl: "",
    src: "/img/svg/faireUnDon.svg",
    icon: <Gift className="w-5 h-5 ml-1" />
  },
  {
    id: 2,
    title: "Partager le site",
    description: "Si tu as apprécié l'expérience ou appris des choses, si tu penses que cela peut intéresser tes proches, ou juste pour nous soutenir, partage ce site autour de toi.<br/><b>Car c'est en sensibilisant à grande échelle qu'on changera les choses</b>.",
    linkUrl: "#",
    src: "/img/svg/partagerSite.svg",
    icon: null
  },
  {
    id: 3,
    title: "Diffuser nos profils",
    description: "Que ce soit pour intervenir dans votre structure pour <b>sensibiliser vos équipes</b>, ou parce que vous connaissez quelqu'un qui connait quelqu'un qui <b>cherche un designer de solutions</b> (#productDesignerGraphique360) pour un projet Freelance ou un poste en CDI.",
    linkUrl: "#",
    src: "/img/svg/diffuserProfils.svg",
    icon: null
  },
  {
    id: 4,
    title: "Mettre la main à la pâte",
    description: "Tu es un <b>maestro du code option accessibilité numérique</b> ou tu en connais un ? Tu souhaites participer à ce projet pour le faire grandir en le rendant vraiment accessible au plus grand nombre ? ",
    linkText: "Contacte-nous par mail",
    linkUrl: "mailto:contact@andyk.app",
    src: "/img/svg/AndyK-Dev.svg",
    icon: <EnvelopeSimple className="w-5 h-5 ml-1" />
  }
];

export const HelpSection: React.FC = () => {
  return (
    <section className="max-w-[1440px] mx-auto px-20 py-20">
      <motion.div
        variants={standardVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
      >
        <Title level={2} className="!text-4xl !font-bold !text-center !mb-10">
          Comment nous aider ?
        </Title>
      </motion.div>
      
      <div className="max-w-[1280px] mx-auto">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-50px" }}
        >
          <Row gutter={[20, 20]}>
            {helpData.map((help) => (
              <Col xs={24} lg={12} key={help.id}>
                <div className="h-full" >
                  <div className="h-full bg-neutral-white border-none gradient-border-1 gradient-border-conic-vibrant rounded-xl">
                    <div className="w-full flex gap-6">
                      <div className="flex-shrink-0 h-full flex items-end self-end">
                        <img alt='' src={help.src} />
                      </div>
                      
                      <div className="flex-1 h-full self-center gap-2 pr-4 py-4">
                        <Title level={4} className="!text-xl !font-semibold">
                          {help.title}
                        </Title>
                        <Paragraph className="!text-base !leading-relaxed">
                          <span dangerouslySetInnerHTML={{ __html: help.description }}></span>
                        </Paragraph>
                        {help.linkText && ( 
                          <a 
                            aria-disabled={(help.linkUrl==="")?'true':'false'}
                            tabIndex={(help.linkUrl==="")?"-1":''}
                            href={help.linkUrl}
                            className="no-underline btn-tertiary gap-1 !text-base font-bold inline-flex items-center pr-3"
                          >
                            {help.icon}
                            {help.linkText}
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </motion.div>
      </div>
    </section>
  );
};